// `/settings/$section` — dynamic dispatch to the right section component.
//
// Single-route dispatch (vs 6 sibling routes) keeps the sub-nav transitions
// cheap and the routeTree small. Unknown sections redirect to `profile`
// so a stale link never lands on a 404.

import { createRoute, redirect } from '@tanstack/react-router';

import { Abonnement } from '@/features/settings/sections/Abonnement';
import { Apparence } from '@/features/settings/sections/Apparence';
import { Notifications } from '@/features/settings/sections/Notifications';
import { PremiersPas } from '@/features/settings/sections/PremiersPas';
import { Profil } from '@/features/settings/sections/Profil';
import { Securite } from '@/features/settings/sections/Securite';
import { SETTINGS_SECTIONS } from '@/features/settings/lib/sections';

import { Route as SettingsLayoutRoute } from './__layout';

const KNOWN = new Set(SETTINGS_SECTIONS.map((s) => s.path));

export const Route = createRoute({
  getParentRoute: () => SettingsLayoutRoute,
  path: '$section',
  beforeLoad: ({ params }) => {
    if (!KNOWN.has(params.section as (typeof SETTINGS_SECTIONS)[number]['path'])) {
      throw redirect({ to: '/settings/$section', params: { section: 'profile' } });
    }
  },
  component: SettingsSectionRoute,
});

function SettingsSectionRoute() {
  const { section } = Route.useParams();
  switch (section) {
    case 'profile':
      return <Profil />;
    case 'appearance':
      return <Apparence />;
    case 'notifications':
      return <Notifications />;
    case 'security':
      return <Securite />;
    case 'billing':
      return <Abonnement />;
    case 'start':
      return <PremiersPas />;
    default:
      return <Profil />;
  }
}
